import { render, staticRenderFns } from "./TopPortfolioTotalPl.vue?vue&type=template&id=6d6a6772&"
import script from "./TopPortfolioTotalPl.vue?vue&type=script&lang=js&"
export * from "./TopPortfolioTotalPl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports